export const setTopPosition = (className, ref) => {
  const node = ref.current;
  const element = document.querySelectorAll(className);
  if (!element && !node) {
    return;
  }

  if (
    typeof node === 'object' &&
    node !== null &&
    'getBoundingClientRect' in node
  ) {
    const { top } = node?.getBoundingClientRect();
    element.forEach(p => p.style.setProperty('top', `${top + 50}px`));
  }
};
